// extracted by mini-css-extract-plugin
export default {"failedToSaveText":"ElectricianViewPage_failedToSaveText__9ltg9"};